import * as React from "react"
import type { SVGProps } from "react"
const SvgText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m6.18 14.9-.8 2.23a1 1 0 0 1-.33.42 1 1 0 0 1-.5.15.8.8 0 0 1-.74-.39.8.8 0 0 1-.08-.81l3.45-9.2a1 1 0 0 1 .33-.44q.24-.16.52-.16h.7a1 1 0 0 1 .87.6l3.45 9.23q.17.42-.1.8a.9.9 0 0 1-.72.37 1 1 0 0 1-.5-.16 1 1 0 0 1-.33-.44l-.78-2.2zm.57-1.6h3.28l-1.6-4.55h-.1zm9.88 4.65q-1.28 0-2.03-.69a2.3 2.3 0 0 1-.75-1.81q0-1.1.86-1.81a3.4 3.4 0 0 1 2.22-.71 6 6 0 0 1 2.07.37V13q0-.72-.51-1.17-.52-.45-1.36-.45-.38 0-.74.1-.36.12-.67.35-.32.24-.6.17a1 1 0 0 1-.47-.27.7.7 0 0 1-.18-.48q0-.27.28-.47.49-.4 1.13-.6.62-.18 1.27-.18 1.72 0 2.58.81.84.81.84 2.44v3.68q0 .32-.23.55a.8.8 0 0 1-1.11-.02.8.8 0 0 1-.23-.56v-.12h-.1a2.3 2.3 0 0 1-.95.87q-.6.3-1.32.3m.3-1.35q.87 0 1.48-.6t.61-1.4a4 4 0 0 0-1.8-.42 2 2 0 0 0-1.25.35q-.45.35-.45.92 0 .49.4.83.4.32 1 .32" />
  </svg>
)
export default SvgText
